export class BBox {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        BBoxFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_bbox_free(ptr, 0);
    }
    /**
     * @returns {number}
     */
    get x_max() {
        const ret = wasm.__wbg_get_bbox_x_max(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {number}
     */
    get x_min() {
        const ret = wasm.__wbg_get_bbox_x_min(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {number}
     */
    get y_max() {
        const ret = wasm.__wbg_get_bbox_y_max(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {number}
     */
    get y_min() {
        const ret = wasm.__wbg_get_bbox_y_min(this.__wbg_ptr);
        return ret;
    }
    /**
     * @param {number} arg0
     */
    set x_max(arg0) {
        wasm.__wbg_set_bbox_x_max(this.__wbg_ptr, arg0);
    }
    /**
     * @param {number} arg0
     */
    set x_min(arg0) {
        wasm.__wbg_set_bbox_x_min(this.__wbg_ptr, arg0);
    }
    /**
     * @param {number} arg0
     */
    set y_max(arg0) {
        wasm.__wbg_set_bbox_y_max(this.__wbg_ptr, arg0);
    }
    /**
     * @param {number} arg0
     */
    set y_min(arg0) {
        wasm.__wbg_set_bbox_y_min(this.__wbg_ptr, arg0);
    }
}
if (Symbol.dispose) BBox.prototype[Symbol.dispose] = BBox.prototype.free;

/**
 * @enum {0 | 1}
 */
export const ModifierLayout = Object.freeze({
    FullWidthCenter: 0, "0": "FullWidthCenter",
    BottomRight: 1, "1": "BottomRight",
});

export class SvgIcon {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(SvgIcon.prototype);
        obj.__wbg_ptr = ptr;
        SvgIconFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        SvgIconFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_svgicon_free(ptr, 0);
    }
    /**
     * @param {string} cutout_path
     * @param {string} modifier_path
     * @param {SvgModifyOptions} options
     */
    addModifier(cutout_path, modifier_path, options) {
        const ptr0 = passStringToWasm0(cutout_path, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(modifier_path, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        _assertClass(options, SvgModifyOptions);
        var ptr2 = options.__destroy_into_raw();
        const ret = wasm.svgicon_addModifier(this.__wbg_ptr, ptr0, len0, ptr1, len1, ptr2);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @returns {any}
     */
    bbox() {
        const ret = wasm.svgicon_bbox(this.__wbg_ptr);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {SvgSizingParams} params
     */
    formatForFullCanvas(params) {
        _assertClass(params, SvgSizingParams);
        const ret = wasm.svgicon_formatForFullCanvas(this.__wbg_ptr, params.__wbg_ptr);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {number} width
     * @param {number} height
     * @param {string | null | undefined} primary_path
     * @param {string | null | undefined} secondary_path
     * @param {boolean} is_multitone
     * @returns {SvgIcon}
     */
    static fromParts(width, height, primary_path, secondary_path, is_multitone) {
        var ptr0 = isLikeNone(primary_path) ? 0 : passStringToWasm0(primary_path, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len0 = WASM_VECTOR_LEN;
        var ptr1 = isLikeNone(secondary_path) ? 0 : passStringToWasm0(secondary_path, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len1 = WASM_VECTOR_LEN;
        const ret = wasm.svgicon_fromParts(width, height, ptr0, len0, ptr1, len1, is_multitone);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return SvgIcon.__wrap(ret[0]);
    }
    /**
     * @returns {number}
     */
    height() {
        const ret = wasm.svgicon_height(this.__wbg_ptr);
        return ret;
    }
    /**
     * @param {string} input
     * @param {SvgImportParams | null} [params]
     * @returns {SvgIconImportStatus}
     */
    static import(input, params) {
        const ptr0 = passStringToWasm0(input, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        let ptr1 = 0;
        if (!isLikeNone(params)) {
            _assertClass(params, SvgImportParams);
            ptr1 = params.__destroy_into_raw();
        }
        const ret = wasm.svgicon_import(ptr0, len0, ptr1);
        return SvgIconImportStatus.__wrap(ret);
    }
    /**
     * @returns {boolean}
     */
    isMultitone() {
        const ret = wasm.svgicon_isMultitone(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {string | undefined}
     */
    primaryPath() {
        const ret = wasm.svgicon_primaryPath(this.__wbg_ptr);
        return ret;
    }
    /**
     * @param {SvgOutputOptions | null} [options]
     * @returns {Uint8Array}
     */
    renderPng(options) {
        let ptr0 = 0;
        if (!isLikeNone(options)) {
            _assertClass(options, SvgOutputOptions);
            ptr0 = options.__destroy_into_raw();
        }
        const ret = wasm.svgicon_renderPng(this.__wbg_ptr, ptr0);
        if (ret[3]) {
            throw takeFromExternrefTable0(ret[2]);
        }
        var v2 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        return v2;
    }
    /**
     * @returns {string | undefined}
     */
    secondaryPath() {
        const ret = wasm.svgicon_secondaryPath(this.__wbg_ptr);
        return ret;
    }
    /**
     * @param {any[]} paths
     */
    setPaths(paths) {
        const ptr0 = passArrayJsValueToWasm0(paths, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.svgicon_setPaths(this.__wbg_ptr, ptr0, len0);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @returns {string}
     */
    toString() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.svgicon_toString(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {SvgOutputOptions} options
     * @returns {string}
     */
    toStringWithOptions(options) {
        let deferred1_0;
        let deferred1_1;
        try {
            _assertClass(options, SvgOutputOptions);
            const ret = wasm.svgicon_toStringWithOptions(this.__wbg_ptr, options.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {number}
     */
    width() {
        const ret = wasm.svgicon_width(this.__wbg_ptr);
        return ret;
    }
}
if (Symbol.dispose) SvgIcon.prototype[Symbol.dispose] = SvgIcon.prototype.free;

export class SvgIconImportStatus {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(SvgIconImportStatus.prototype);
        obj.__wbg_ptr = ptr;
        SvgIconImportStatusFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        SvgIconImportStatusFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_svgiconimportstatus_free(ptr, 0);
    }
    /**
     * @returns {any[]}
     */
    errors() {
        const ret = wasm.svgiconimportstatus_errors(this.__wbg_ptr);
        var v1 = getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
        wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v1;
    }
    /**
     * @returns {boolean}
     */
    hasError() {
        const ret = wasm.svgiconimportstatus_hasError(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {boolean}
     */
    hasLog() {
        const ret = wasm.svgiconimportstatus_hasLog(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {boolean}
     */
    hasNotice() {
        const ret = wasm.svgiconimportstatus_hasNotice(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {any}
     */
    messages() {
        const ret = wasm.svgiconimportstatus_messages(this.__wbg_ptr);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * Takes the result svg. This can only be done once. Once it's taken,
     * subsequent invocations of this accessor will return `undefined`.
     * @returns {SvgIcon | undefined}
     */
    takeSvg() {
        const ret = wasm.svgiconimportstatus_takeSvg(this.__wbg_ptr);
        return ret === 0 ? undefined : SvgIcon.__wrap(ret);
    }
}
if (Symbol.dispose) SvgIconImportStatus.prototype[Symbol.dispose] = SvgIconImportStatus.prototype.free;

/**
 * @enum {0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 | 14 | 15 | 16 | 17 | 18 | 19 | 20 | 21 | 22 | 23 | 24 | 25 | 26 | 27 | 28 | 29 | 30 | 31 | 32 | 33 | 34 | 35 | 36 | 37 | 38 | 39 | 40 | 41 | 42}
 */
export const SvgImportMessageCode = Object.freeze({
    ParseError: 0, "0": "ParseError",
    MultipleObjects: 1, "1": "MultipleObjects",
    InvalidStructure: 2, "2": "InvalidStructure",
    ShapeStrokes: 3, "3": "ShapeStrokes",
    Fills: 4, "4": "Fills",
    HasImage: 5, "5": "HasImage",
    HasText: 6, "6": "HasText",
    HasLine: 7, "7": "HasLine",
    HasGlyph: 8, "8": "HasGlyph",
    HasMask: 9, "9": "HasMask",
    ExtraneousCodeRemoved: 10, "10": "ExtraneousCodeRemoved",
    OverlappingPoints: 11, "11": "OverlappingPoints",
    LowPrecision: 12, "12": "LowPrecision",
    CssStylesRemoved: 13, "13": "CssStylesRemoved",
    ShapesConverted: 14, "14": "ShapesConverted",
    FailedCirclification: 15, "15": "FailedCirclification",
    FailedShapeConversion: 16, "16": "FailedShapeConversion",
    PathAttributesScrubbed: 17, "17": "PathAttributesScrubbed",
    PathsJoined: 18, "18": "PathsJoined",
    GroupsCollapsed: 19, "19": "GroupsCollapsed",
    ExceedsViewbox: 20, "20": "ExceedsViewbox",
    ViewboxCrop: 21, "21": "ViewboxCrop",
    RemoveHidden: 22, "22": "RemoveHidden",
    ScaledUpFromStandardHeight: 23, "23": "ScaledUpFromStandardHeight",
    ScaledUpFromNonStandardHeight: 24, "24": "ScaledUpFromNonStandardHeight",
    ScaledDown: 25, "25": "ScaledDown",
    ScaleUpFailure: 26, "26": "ScaleUpFailure",
    ScaleDownFailure: 27, "27": "ScaleDownFailure",
    ViewboxDerived: 28, "28": "ViewboxDerived",
    FailedStringification: 29, "29": "FailedStringification",
    FillRuleConversion: 30, "30": "FillRuleConversion",
    ViewboxInvalid: 31, "31": "ViewboxInvalid",
    Optimized: 32, "32": "Optimized",
    FailedOptimizing: 33, "33": "FailedOptimizing",
    SelfIntersection: 34, "34": "SelfIntersection",
    SecondaryOverlapSubtracted: 35, "35": "SecondaryOverlapSubtracted",
    SecondaryFullyOverlapped: 36, "36": "SecondaryFullyOverlapped",
    TooManyPointsTooClose: 37, "37": "TooManyPointsTooClose",
    HeightExceedsCanvas: 38, "38": "HeightExceedsCanvas",
    WidthExceedsCanvas: 39, "39": "WidthExceedsCanvas",
    CropPaddingHeightTooShort: 40, "40": "CropPaddingHeightTooShort",
    InvalidTransform: 41, "41": "InvalidTransform",
    RemovedExtraPoints: 42, "42": "RemovedExtraPoints",
});

/**
 * @enum {0 | 1 | 2}
 */
export const SvgImportMessageKind = Object.freeze({
    Notice: 0, "0": "Notice",
    Error: 1, "1": "Error",
    Log: 2, "2": "Log",
});

export class SvgImportParams {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(SvgImportParams.prototype);
        obj.__wbg_ptr = ptr;
        SvgImportParamsFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        SvgImportParamsFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_svgimportparams_free(ptr, 0);
    }
    /**
     * When None, do not attempt to remove extra points.
     * When Some, remove extra points with the given accuracy.
     * Default: 0.001
     * @returns {number | undefined}
     */
    get extra_points_removal_accuracy() {
        const ret = wasm.__wbg_get_svgimportparams_extra_points_removal_accuracy(this.__wbg_ptr);
        return ret[0] === 0 ? undefined : ret[1];
    }
    /**
     * When None, do not attempt to remove extra points.
     * When Some, remove extra points with the given accuracy.
     * Default: 0.001
     * @param {number | null} [arg0]
     */
    set extra_points_removal_accuracy(arg0) {
        wasm.__wbg_set_svgimportparams_extra_points_removal_accuracy(this.__wbg_ptr, !isLikeNone(arg0), isLikeNone(arg0) ? 0 : arg0);
    }
    /**
     * Updates the `message_map` to allow canvas overflow messages.
     * Sets `HeightExceedsCanvas` and `WidthExceedsCanvas` to `Notice`.
     */
    allowCanvasOverflow() {
        wasm.svgimportparams_allowCanvasOverflow(this.__wbg_ptr);
    }
    /**
     * @returns {SvgImportParams}
     */
    static default() {
        const ret = wasm.svgimportparams_default();
        return SvgImportParams.__wrap(ret);
    }
    /**
     * @returns {SvgImportParams}
     */
    static fa6Default() {
        const ret = wasm.svgimportparams_fa6Default();
        return SvgImportParams.__wrap(ret);
    }
    /**
     * @returns {SvgImportParams}
     */
    static fa7Default() {
        const ret = wasm.svgimportparams_default();
        return SvgImportParams.__wrap(ret);
    }
    /**
     * @returns {any}
     */
    getMessageMap() {
        const ret = wasm.svgimportparams_getMessageMap(this.__wbg_ptr);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {boolean} circlify
     */
    setCirclify(circlify) {
        wasm.svgimportparams_setCirclify(this.__wbg_ptr, circlify);
    }
    /**
     * @param {number | null} [accuracy]
     */
    setExtraPointsRemovalAccuracy(accuracy) {
        wasm.svgimportparams_setExtraPointsRemovalAccuracy(this.__wbg_ptr, !isLikeNone(accuracy), isLikeNone(accuracy) ? 0 : accuracy);
    }
    /**
     * @param {boolean} optimize
     */
    setOptimize(optimize) {
        wasm.svgimportparams_setOptimize(this.__wbg_ptr, optimize);
    }
    /**
     * @param {SvgImportMessageCode} code
     * @param {SvgImportMessageKind | null} [kind]
     */
    updateMessageMap(code, kind) {
        wasm.svgimportparams_updateMessageMap(this.__wbg_ptr, code, isLikeNone(kind) ? 3 : kind);
    }
}
if (Symbol.dispose) SvgImportParams.prototype[Symbol.dispose] = SvgImportParams.prototype.free;

export class SvgModifyOptions {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        SvgModifyOptionsFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_svgmodifyoptions_free(ptr, 0);
    }
    /**
     * Whether the resulting SVG should be duotone. If so, the base SVG,
     * after subtracting the cutout, will become the primary path,
     * and the modifier will be the secondary path.
     * @returns {boolean}
     */
    get duotone() {
        const ret = wasm.__wbg_get_svgmodifyoptions_duotone(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {ModifierLayout}
     */
    get layout() {
        const ret = wasm.__wbg_get_svgmodifyoptions_layout(this.__wbg_ptr);
        return ret;
    }
    /**
     * Whether the resulting SVG should be duotone. If so, the base SVG,
     * after subtracting the cutout, will become the primary path,
     * and the modifier will be the secondary path.
     * @param {boolean} arg0
     */
    set duotone(arg0) {
        wasm.__wbg_set_svgmodifyoptions_duotone(this.__wbg_ptr, arg0);
    }
    /**
     * @param {ModifierLayout} arg0
     */
    set layout(arg0) {
        wasm.__wbg_set_svgmodifyoptions_layout(this.__wbg_ptr, arg0);
    }
    /**
     * Config params:
     *
     * - layout: ModifierLayout (default: FullWidthCenter)
     * - duotone: boolean (default: false)
     * @param {any} params
     */
    constructor(params) {
        const ret = wasm.svgmodifyoptions_new_js(params);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        this.__wbg_ptr = ret[0] >>> 0;
        SvgModifyOptionsFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
}
if (Symbol.dispose) SvgModifyOptions.prototype[Symbol.dispose] = SvgModifyOptions.prototype.free;

export class SvgOutputOptions {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(SvgOutputOptions.prototype);
        obj.__wbg_ptr = ptr;
        SvgOutputOptionsFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        SvgOutputOptionsFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_svgoutputoptions_free(ptr, 0);
    }
    /**
     * Add a stylesheet to be injected into `<defs><style> ... </defs></style>`
     * when writing out the SVG.
     *
     * `mode` may be:
     * - `Prepend` to add the given stylesheet is added before any
     * default stylesheet.
     * - `Append` to add the given stylesheet after any default stylesheet.
     * - `Replace` to replace any default stylesheet.
     *
     * A typical default stylesheet is the secondary opacity rule for duotone SVGs.
     *
     * Adding a stylesheet only works when the `SvgPropertyTemplate`
     * is `File` (the default), and is a noop for `Font` or `SvgSpriteFile`, since those formats
     * do not respect additional stylesheets in the SVG.
     * @param {string} stylesheet
     * @param {SvgStylesheetMode} mode
     */
    addStylesheet(stylesheet, mode) {
        const ptr0 = passStringToWasm0(stylesheet, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.svgoutputoptions_addStylesheet(this.__wbg_ptr, ptr0, len0, mode);
    }
    configAsInlineStyleFile() {
        wasm.svgoutputoptions_configAsInlineStyleFile(this.__wbg_ptr);
    }
    configAsPresentationAttributesFile() {
        wasm.svgoutputoptions_configAsPresentationAttributesFile(this.__wbg_ptr);
    }
    configAsSvgSpriteFile() {
        wasm.svgoutputoptions_configAsSvgSpriteFile(this.__wbg_ptr);
    }
    /**
     * @param {any} color_options_js_value
     */
    configForColorPng(color_options_js_value) {
        const ret = wasm.svgoutputoptions_configForColorPng(this.__wbg_ptr, color_options_js_value);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @returns {SvgOutputOptions}
     */
    static default() {
        const ret = wasm.svgoutputoptions_default();
        return SvgOutputOptions.__wrap(ret);
    }
    /**
     * @returns {string}
     */
    static defaultPrimaryClass() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.svgoutputoptions_defaultPrimaryClass();
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */
    static defaultSecondaryClass() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.svgoutputoptions_defaultSecondaryClass();
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * Use this to get the default options for writing out an SVG file
     * for Font Awesome 6.
     * @returns {SvgOutputOptions}
     */
    static defaultSvgFileFa6() {
        const ret = wasm.svgoutputoptions_defaultSvgFileFa6();
        return SvgOutputOptions.__wrap(ret);
    }
    /**
     * Use this to get the default options for writing out an SVG file
     * for Font Awesome 7.
     *
     * Equivalent to instantiating a default `SvgOutputOptions` and configuring
     * the property template as `SvgPropertyTemplate::InlineStyleFile`.
     * @returns {SvgOutputOptions}
     */
    static defaultSvgFileFa7() {
        const ret = wasm.svgoutputoptions_default();
        return SvgOutputOptions.__wrap(ret);
    }
    /**
     * @returns {string}
     */
    static defaultXmlns() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.svgoutputoptions_defaultXmlns();
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {any}
     */
    inspect() {
        const ret = wasm.svgoutputoptions_inspect(this.__wbg_ptr);
        return ret;
    }
    /**
     * Construct with defaults.
     * @param {any} params
     */
    constructor(params) {
        const ret = wasm.svgoutputoptions_new_js(params);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        this.__wbg_ptr = ret[0] >>> 0;
        SvgOutputOptionsFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * Equivalent to round_sigfigs().
     * @param {number} round_to_significant_digits
     * @returns {SvgOutputOptions}
     */
    static round(round_to_significant_digits) {
        const ret = wasm.svgoutputoptions_round(round_to_significant_digits);
        return SvgOutputOptions.__wrap(ret);
    }
    /**
     * Round to the given number of decimal places.
     * @param {number} round_to_decimal_places
     * @returns {SvgOutputOptions}
     */
    static roundDecimalPlaces(round_to_decimal_places) {
        const ret = wasm.svgoutputoptions_roundDecimalPlaces(round_to_decimal_places);
        return SvgOutputOptions.__wrap(ret);
    }
    /**
     * Round to the given number of significant digits.
     * @param {number} round_to_significant_digits
     * @returns {SvgOutputOptions}
     */
    static roundSigfigs(round_to_significant_digits) {
        const ret = wasm.svgoutputoptions_round(round_to_significant_digits);
        return SvgOutputOptions.__wrap(ret);
    }
    /**
     * Add height attribute to the stringified SVG.
     *
     * This only works when the `SvgPropertyTemplate`
     * is `File` (the default), and is a noop for `Font` or `SvgSpriteFile`.
     * @param {string} height
     */
    setHeight(height) {
        const ptr0 = passStringToWasm0(height, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.svgoutputoptions_setHeight(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * Output options appropriate for stringifying an SVG sprite file, like solid.svg.
     * @returns {SvgOutputOptions}
     */
    static svgSpriteFileFa6() {
        const ret = wasm.svgoutputoptions_svgSpriteFileFa6();
        return SvgOutputOptions.__wrap(ret);
    }
    /**
     * @returns {SvgOutputOptions}
     */
    static svgSpriteFileFa7() {
        const ret = wasm.svgoutputoptions_svgSpriteFileFa7();
        return SvgOutputOptions.__wrap(ret);
    }
    /**
     * Output options appropriate for stringifying SVGs for a font's svg table.
     * @param {string} translate
     * @returns {SvgOutputOptions}
     */
    static svgTable(translate) {
        const ptr0 = passStringToWasm0(translate, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.svgoutputoptions_svgTable(ptr0, len0);
        return SvgOutputOptions.__wrap(ret);
    }
}
if (Symbol.dispose) SvgOutputOptions.prototype[Symbol.dispose] = SvgOutputOptions.prototype.free;

/**
 * When writing SVGs out as strings, we write them out in differents ways,
 * depending on whether we're creating raw .svg files like are shipped
 * in the "svgs" directory of our download zip archives (`File`), customizing
 * .svg files primarily for use in Desktop apps (`PresentationAttributesFile`),
 * SVG sprite files, or writing them into an SVG font table.
 *
 * The main difference between `File` and `PresentationAttrbutesFile` is that
 * the former uses a stylesheet for Duotone opacity, while the latter does
 * not. A stylesheet can still be *added* when using `PresentationAttributesFile`,
 * but by default, only presentation attributes are used.
 *
 * The main difference between `PresentationAttributesFile` and `InlineStyleFile` is that
 * the latter uses an inline `style` attribute for all styling, rather than presentation
 * attributes.
 * @enum {0 | 1 | 2 | 3 | 4}
 */
export const SvgPropertyTemplate = Object.freeze({
    File: 0, "0": "File",
    Font: 1, "1": "Font",
    SvgSpriteFile: 2, "2": "SvgSpriteFile",
    PresentationAttributesFile: 3, "3": "PresentationAttributesFile",
    InlineStyleFile: 4, "4": "InlineStyleFile",
});

/**
 * Parameters used primarily for determing the size and final
 * viewBox height when scaling an SVG.
 *
 * The `target_canvas_width` and `target_canvas_height` values are
 * used for re-formatting SVGs onto the full canvas, including padding.
 * This is what "squares" them, in FA7 parlance.
 */
export class SvgSizingParams {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(SvgSizingParams.prototype);
        obj.__wbg_ptr = ptr;
        SvgSizingParamsFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        SvgSizingParamsFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_svgsizingparams_free(ptr, 0);
    }
    /**
     * Icons may be designed on a canvas with an inner grid surrounded by padding.
     * For Font Awesome 7, the canvas is normally 20x20, with an icon grid of 16x16.
     * Thus, the padding is 2 pixels on all sides.
     *
     * This value is used when importing SVGs, for example. The canvas must be cropped
     * down to the size of the grid before scaling it up to the `target_grid_height`.
     *
     * For Font Awesome 7, this value should probably be 16.
     *
     * For Font Awesome 6, there was no padding, so this should be None.
     * @returns {number}
     */
    get sourceGridHeight() {
        const ret = wasm.__wbg_get_svgsizingparams_sourceGridHeight(this.__wbg_ptr);
        return ret;
    }
    /**
     * The "standard" height of the canvas for an SVG. This is the same
     * as the viewBox height.
     *
     * Padding is computed as `standard_source_canvas_height - source_grid_height`.
     * @returns {number}
     */
    get standardSourceCanvasHeight() {
        const ret = wasm.__wbg_get_svgsizingparams_standardSourceCanvasHeight(this.__wbg_ptr);
        return ret;
    }
    /**
     * The full target canvas height to be used when re-formatting
     * squeezed and squashed SVGs for the full canvas dimensions.
     * This is not the value used for scaling. See `target_grid_height`.
     * For FA5, and and FA6, this should be 512. For FA7, this should be 640.
     * @returns {number}
     */
    get targetCanvasHeight() {
        const ret = wasm.__wbg_get_svgsizingparams_targetCanvasHeight(this.__wbg_ptr);
        return ret;
    }
    /**
     * The full target canvas width to be used when re-formatting
     * squeezed and squashed SVGs for the full canvas dimensions.
     * For FA5, FA6, and FA7, this should be 640.
     * @returns {number}
     */
    get targetCanvasWidth() {
        const ret = wasm.__wbg_get_svgsizingparams_targetCanvasWidth(this.__wbg_ptr);
        return ret;
    }
    /**
     * The height to be used to determine the scaling factor for paths,
     * and also to use as the height of the resulting viewBox.
     * For FA5, FA6, and FA7, this is always 512.
     * @returns {number}
     */
    get targetGridHeight() {
        const ret = wasm.__wbg_get_svgsizingparams_targetGridHeight(this.__wbg_ptr);
        return ret;
    }
    /**
     * Icons may be designed on a canvas with an inner grid surrounded by padding.
     * For Font Awesome 7, the canvas is normally 20x20, with an icon grid of 16x16.
     * Thus, the padding is 2 pixels on all sides.
     *
     * This value is used when importing SVGs, for example. The canvas must be cropped
     * down to the size of the grid before scaling it up to the `target_grid_height`.
     *
     * For Font Awesome 7, this value should probably be 16.
     *
     * For Font Awesome 6, there was no padding, so this should be None.
     * @param {number} arg0
     */
    set sourceGridHeight(arg0) {
        wasm.__wbg_set_svgsizingparams_sourceGridHeight(this.__wbg_ptr, arg0);
    }
    /**
     * The "standard" height of the canvas for an SVG. This is the same
     * as the viewBox height.
     *
     * Padding is computed as `standard_source_canvas_height - source_grid_height`.
     * @param {number} arg0
     */
    set standardSourceCanvasHeight(arg0) {
        wasm.__wbg_set_svgsizingparams_standardSourceCanvasHeight(this.__wbg_ptr, arg0);
    }
    /**
     * The full target canvas height to be used when re-formatting
     * squeezed and squashed SVGs for the full canvas dimensions.
     * This is not the value used for scaling. See `target_grid_height`.
     * For FA5, and and FA6, this should be 512. For FA7, this should be 640.
     * @param {number} arg0
     */
    set targetCanvasHeight(arg0) {
        wasm.__wbg_set_svgsizingparams_targetCanvasHeight(this.__wbg_ptr, arg0);
    }
    /**
     * The full target canvas width to be used when re-formatting
     * squeezed and squashed SVGs for the full canvas dimensions.
     * For FA5, FA6, and FA7, this should be 640.
     * @param {number} arg0
     */
    set targetCanvasWidth(arg0) {
        wasm.__wbg_set_svgsizingparams_targetCanvasWidth(this.__wbg_ptr, arg0);
    }
    /**
     * The height to be used to determine the scaling factor for paths,
     * and also to use as the height of the resulting viewBox.
     * For FA5, FA6, and FA7, this is always 512.
     * @param {number} arg0
     */
    set targetGridHeight(arg0) {
        wasm.__wbg_set_svgsizingparams_targetGridHeight(this.__wbg_ptr, arg0);
    }
    /**
     * @returns {SvgSizingParams}
     */
    static fa6Default() {
        const ret = wasm.svgsizingparams_fa6Default();
        return SvgSizingParams.__wrap(ret);
    }
    /**
     * @returns {SvgSizingParams}
     */
    static fa7Default() {
        const ret = wasm.svgsizingparams_fa7Default();
        return SvgSizingParams.__wrap(ret);
    }
    /**
     * Create a new instance of `SvgSizingParams` from a JS object.
     * If the object is undefined, then the default FA7 params are used.
     * @param {any} params
     */
    constructor(params) {
        const ret = wasm.svgsizingparams_new_js(params);
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        this.__wbg_ptr = ret[0] >>> 0;
        SvgSizingParamsFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * Standard padding is determined as `standard_scale_factor() * (standard_source_canvas_height - source_grid_height)`.
     * If this would result in a negative value, `None` is returned.
     * `None` is also return if the scale_factor is not a whole number,
     * or if it would exceed the size of a u16.
     * @returns {number | undefined}
     */
    standard_padding_scaled() {
        const ret = wasm.svgsizingparams_standard_padding_scaled(this.__wbg_ptr);
        return ret === 0xFFFFFF ? undefined : ret;
    }
    /**
     * Standard padding is determined as `(standard_source_canvas_height - source_grid_height) / 2`.
     * If this would result in a negative or non-integer value, `None` is returned.
     * @returns {number | undefined}
     */
    standard_padding_unscaled() {
        const ret = wasm.svgsizingparams_standard_padding_unscaled(this.__wbg_ptr);
        return ret === 0xFFFFFF ? undefined : ret;
    }
    /**
     * The scale factor used when and SVG's viewBox height
     * equals the `standard_source_canvas_height`.
     *
     * Otherwise, the actual scale factor for a given SVG is based on
     * its viewBox height, and will be different from this standard value.
     * @returns {number | undefined}
     */
    standard_scale_factor() {
        const ret = wasm.svgsizingparams_standard_scale_factor(this.__wbg_ptr);
        return ret === 0xFFFFFF ? undefined : ret;
    }
    /**
     * The number of units per pixel of an SVG scaled according to these parameters
     * when the SVG's viewBox height is equal to the `standard_source_canvas_height`.
     *
     * This happens to be the same as the `standard_scale_factor()`.
     * @returns {number | undefined}
     */
    units_per_pixel() {
        const ret = wasm.svgsizingparams_units_per_pixel(this.__wbg_ptr);
        return ret === 0xFFFFFF ? undefined : ret;
    }
}
if (Symbol.dispose) SvgSizingParams.prototype[Symbol.dispose] = SvgSizingParams.prototype.free;

/**
 * When writing SVGs out as strings where a stylesheet has been added to the
 * `SvgOutputOptions` via `add_stylesheet()`, should the given stylesheet
 * _replace_ any default stylesheet, or be prepended, or appended to any default
 * stylesheet?
 * @enum {0 | 1 | 2}
 */
export const SvgStylesheetMode = Object.freeze({
    Replace: 0, "0": "Replace",
    Append: 1, "1": "Append",
    Prepend: 2, "2": "Prepend",
});

/**
 * @enum {0 | 1 | 2}
 */
export const WidthMode = Object.freeze({
    Preserve: 0, "0": "Preserve",
    /**
     * The FA6 method of automatically trimming SVG widths on import.
     * This would be applied to a whole style group for a given icon.
     * It's obsolete and only here for historical purposes. Probably
     * should not be used for new imports.
     */
    SqueezeCrop: 1, "1": "SqueezeCrop",
    /**
     * The FA7 method of automatically trimming SVG widths on import.
     * This is normally applied to individual icons. It involves
     * a little flexibility when determining the viewBox: the squeeze box
     * width will be rounded up or down to the nearest whole pixel, before
     * fitting it into the smallest available standard width.
     */
    FreshSqueeze: 2, "2": "FreshSqueeze",
});

export class WidthModeParams {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(WidthModeParams.prototype);
        obj.__wbg_ptr = ptr;
        WidthModeParamsFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        WidthModeParamsFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_widthmodeparams_free(ptr, 0);
    }
    /**
     * @returns {WidthModeParams}
     */
    static default() {
        const ret = wasm.widthmodeparams_default();
        return WidthModeParams.__wrap(ret);
    }
    /**
     * A default for the FA7 FreshSqueeze mode, using the
     * provided standard widths.
     * @param {Uint16Array} valid_widths
     * @returns {WidthModeParams}
     */
    static fresh_squeeze(valid_widths) {
        const ptr0 = passArray16ToWasm0(valid_widths, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.widthmodeparams_fresh_squeeze(ptr0, len0);
        return WidthModeParams.__wrap(ret);
    }
    /**
     * @returns {WidthModeParams}
     */
    static preserve() {
        const ret = wasm.widthmodeparams_default();
        return WidthModeParams.__wrap(ret);
    }
    /**
     * A default for the FA6 SqueezeCrop mode, using the
     * provided standard widths.
     * @param {Uint16Array} valid_widths
     * @returns {WidthModeParams}
     */
    static squeeze_crop(valid_widths) {
        const ptr0 = passArray16ToWasm0(valid_widths, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.widthmodeparams_squeeze_crop(ptr0, len0);
        return WidthModeParams.__wrap(ret);
    }
}
if (Symbol.dispose) WidthModeParams.prototype[Symbol.dispose] = WidthModeParams.prototype.free;

/**
 * @returns {string}
 */
export function iconNameRequirements() {
    let deferred1_0;
    let deferred1_1;
    try {
        const ret = wasm.iconNameRequirements();
        deferred1_0 = ret[0];
        deferred1_1 = ret[1];
        return getStringFromWasm0(ret[0], ret[1]);
    } finally {
        wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
    }
}

/**
 * Parse a standard Font Awesome SVG into an SvgIcon.
 * This does a shallow parsing of the SVG's paths and retains
 * the paths as Strings.
 *
 * It does not parse the path data strings, but keeps them exactly
 * as they are, so that subsequent invocations of `.primaryPath()`,
 * `.secondaryPath()`, or `.toString()` will yield the exact values
 * that were present in the original.
 * @param {string} content
 * @returns {SvgIcon}
 */
export function parseStandard(content) {
    const ptr0 = passStringToWasm0(content, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.parseStandard(ptr0, len0);
    if (ret[2]) {
        throw takeFromExternrefTable0(ret[1]);
    }
    return SvgIcon.__wrap(ret[0]);
}

/**
 * @param {any} named_svgs_js
 * @param {SvgOutputOptions} options
 * @returns {string}
 */
export function svgsAsSprite(named_svgs_js, options) {
    let deferred2_0;
    let deferred2_1;
    try {
        _assertClass(options, SvgOutputOptions);
        const ret = wasm.svgsAsSprite(named_svgs_js, options.__wbg_ptr);
        var ptr1 = ret[0];
        var len1 = ret[1];
        if (ret[3]) {
            ptr1 = 0; len1 = 0;
            throw takeFromExternrefTable0(ret[2]);
        }
        deferred2_0 = ptr1;
        deferred2_1 = len1;
        return getStringFromWasm0(ptr1, len1);
    } finally {
        wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
    }
}

/**
 * @param {string} name
 * @returns {boolean}
 */
export function validateIconName(name) {
    const ptr0 = passStringToWasm0(name, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.validateIconName(ptr0, len0);
    return ret !== 0;
}
export function __wbg_Error_8c4e43fe74559d73(arg0, arg1) {
    const ret = Error(getStringFromWasm0(arg0, arg1));
    return ret;
}
export function __wbg_Number_04624de7d0e8332d(arg0) {
    const ret = Number(arg0);
    return ret;
}
export function __wbg_String_8f0eb39a4a4c2f66(arg0, arg1) {
    const ret = String(arg1);
    const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
    getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
}
export function __wbg___wbindgen_boolean_get_bbbb1c18aa2f5e25(arg0) {
    const v = arg0;
    const ret = typeof(v) === 'boolean' ? v : undefined;
    return isLikeNone(ret) ? 0xFFFFFF : ret ? 1 : 0;
}
export function __wbg___wbindgen_debug_string_0bc8482c6e3508ae(arg0, arg1) {
    const ret = debugString(arg1);
    const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
    getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
}
export function __wbg___wbindgen_in_47fa6863be6f2f25(arg0, arg1) {
    const ret = arg0 in arg1;
    return ret;
}
export function __wbg___wbindgen_is_function_0095a73b8b156f76(arg0) {
    const ret = typeof(arg0) === 'function';
    return ret;
}
export function __wbg___wbindgen_is_object_5ae8e5880f2c1fbd(arg0) {
    const val = arg0;
    const ret = typeof(val) === 'object' && val !== null;
    return ret;
}
export function __wbg___wbindgen_is_string_cd444516edc5b180(arg0) {
    const ret = typeof(arg0) === 'string';
    return ret;
}
export function __wbg___wbindgen_is_undefined_9e4d92534c42d778(arg0) {
    const ret = arg0 === undefined;
    return ret;
}
export function __wbg___wbindgen_jsval_loose_eq_9dd77d8cd6671811(arg0, arg1) {
    const ret = arg0 == arg1;
    return ret;
}
export function __wbg___wbindgen_number_get_8ff4255516ccad3e(arg0, arg1) {
    const obj = arg1;
    const ret = typeof(obj) === 'number' ? obj : undefined;
    getDataViewMemory0().setFloat64(arg0 + 8 * 1, isLikeNone(ret) ? 0 : ret, true);
    getDataViewMemory0().setInt32(arg0 + 4 * 0, !isLikeNone(ret), true);
}
export function __wbg___wbindgen_string_get_72fb696202c56729(arg0, arg1) {
    const obj = arg1;
    const ret = typeof(obj) === 'string' ? obj : undefined;
    var ptr1 = isLikeNone(ret) ? 0 : passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    var len1 = WASM_VECTOR_LEN;
    getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
    getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
}
export function __wbg___wbindgen_throw_be289d5034ed271b(arg0, arg1) {
    throw new Error(getStringFromWasm0(arg0, arg1));
}
export function __wbg_call_389efe28435a9388() { return handleError(function (arg0, arg1) {
    const ret = arg0.call(arg1);
    return ret;
}, arguments); }
export function __wbg_done_57b39ecd9addfe81(arg0) {
    const ret = arg0.done;
    return ret;
}
export function __wbg_entries_58c7934c745daac7(arg0) {
    const ret = Object.entries(arg0);
    return ret;
}
export function __wbg_from_bddd64e7d5ff6941(arg0) {
    const ret = Array.from(arg0);
    return ret;
}
export function __wbg_get_9b94d73e6221f75c(arg0, arg1) {
    const ret = arg0[arg1 >>> 0];
    return ret;
}
export function __wbg_get_b3ed3ad4be2bc8ac() { return handleError(function (arg0, arg1) {
    const ret = Reflect.get(arg0, arg1);
    return ret;
}, arguments); }
export function __wbg_get_with_ref_key_1dc361bd10053bfe(arg0, arg1) {
    const ret = arg0[arg1];
    return ret;
}
export function __wbg_instanceof_ArrayBuffer_c367199e2fa2aa04(arg0) {
    let result;
    try {
        result = arg0 instanceof ArrayBuffer;
    } catch (_) {
        result = false;
    }
    const ret = result;
    return ret;
}
export function __wbg_instanceof_Uint8Array_9b9075935c74707c(arg0) {
    let result;
    try {
        result = arg0 instanceof Uint8Array;
    } catch (_) {
        result = false;
    }
    const ret = result;
    return ret;
}
export function __wbg_isArray_d314bb98fcf08331(arg0) {
    const ret = Array.isArray(arg0);
    return ret;
}
export function __wbg_isSafeInteger_bfbc7332a9768d2a(arg0) {
    const ret = Number.isSafeInteger(arg0);
    return ret;
}
export function __wbg_iterator_6ff6560ca1568e55() {
    const ret = Symbol.iterator;
    return ret;
}
export function __wbg_length_32ed9a279acd054c(arg0) {
    const ret = arg0.length;
    return ret;
}
export function __wbg_length_35a7bace40f36eac(arg0) {
    const ret = arg0.length;
    return ret;
}
export function __wbg_new_361308b2356cecd0() {
    const ret = new Object();
    return ret;
}
export function __wbg_new_dca287b076112a51() {
    const ret = new Map();
    return ret;
}
export function __wbg_new_dd2b680c8bf6ae29(arg0) {
    const ret = new Uint8Array(arg0);
    return ret;
}
export function __wbg_next_3482f54c49e8af19() { return handleError(function (arg0) {
    const ret = arg0.next();
    return ret;
}, arguments); }
export function __wbg_next_418f80d8f5303233(arg0) {
    const ret = arg0.next;
    return ret;
}
export function __wbg_prototypesetcall_bdcdcc5842e4d77d(arg0, arg1, arg2) {
    Uint8Array.prototype.set.call(getArrayU8FromWasm0(arg0, arg1), arg2);
}
export function __wbg_set_1eb0999cf5d27fc8(arg0, arg1, arg2) {
    const ret = arg0.set(arg1, arg2);
    return ret;
}
export function __wbg_set_3f1d0b984ed272ed(arg0, arg1, arg2) {
    arg0[arg1] = arg2;
}
export function __wbg_value_0546255b415e96c1(arg0) {
    const ret = arg0.value;
    return ret;
}
export function __wbg_values_dc546c4b4dd99ba8(arg0) {
    const ret = arg0.values();
    return ret;
}
export function __wbindgen_cast_0000000000000001(arg0) {
    // Cast intrinsic for `F64 -> Externref`.
    const ret = arg0;
    return ret;
}
export function __wbindgen_cast_0000000000000002(arg0, arg1) {
    // Cast intrinsic for `Ref(String) -> Externref`.
    const ret = getStringFromWasm0(arg0, arg1);
    return ret;
}
export function __wbindgen_init_externref_table() {
    const table = wasm.__wbindgen_externrefs;
    const offset = table.grow(4);
    table.set(0, undefined);
    table.set(offset + 0, undefined);
    table.set(offset + 1, null);
    table.set(offset + 2, true);
    table.set(offset + 3, false);
}
const BBoxFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_bbox_free(ptr >>> 0, 1));
const SvgIconFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_svgicon_free(ptr >>> 0, 1));
const SvgIconImportStatusFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_svgiconimportstatus_free(ptr >>> 0, 1));
const SvgImportParamsFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_svgimportparams_free(ptr >>> 0, 1));
const SvgModifyOptionsFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_svgmodifyoptions_free(ptr >>> 0, 1));
const SvgOutputOptionsFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_svgoutputoptions_free(ptr >>> 0, 1));
const SvgSizingParamsFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_svgsizingparams_free(ptr >>> 0, 1));
const WidthModeParamsFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_widthmodeparams_free(ptr >>> 0, 1));

function addToExternrefTable0(obj) {
    const idx = wasm.__externref_table_alloc();
    wasm.__wbindgen_externrefs.set(idx, obj);
    return idx;
}

function _assertClass(instance, klass) {
    if (!(instance instanceof klass)) {
        throw new Error(`expected instance of ${klass.name}`);
    }
}

function debugString(val) {
    // primitive types
    const type = typeof val;
    if (type == 'number' || type == 'boolean' || val == null) {
        return  `${val}`;
    }
    if (type == 'string') {
        return `"${val}"`;
    }
    if (type == 'symbol') {
        const description = val.description;
        if (description == null) {
            return 'Symbol';
        } else {
            return `Symbol(${description})`;
        }
    }
    if (type == 'function') {
        const name = val.name;
        if (typeof name == 'string' && name.length > 0) {
            return `Function(${name})`;
        } else {
            return 'Function';
        }
    }
    // objects
    if (Array.isArray(val)) {
        const length = val.length;
        let debug = '[';
        if (length > 0) {
            debug += debugString(val[0]);
        }
        for(let i = 1; i < length; i++) {
            debug += ', ' + debugString(val[i]);
        }
        debug += ']';
        return debug;
    }
    // Test for built-in
    const builtInMatches = /\[object ([^\]]+)\]/.exec(toString.call(val));
    let className;
    if (builtInMatches && builtInMatches.length > 1) {
        className = builtInMatches[1];
    } else {
        // Failed to match the standard '[object ClassName]'
        return toString.call(val);
    }
    if (className == 'Object') {
        // we're a user defined class or Object
        // JSON.stringify avoids problems with cycles, and is generally much
        // easier than looping through ownProperties of `val`.
        try {
            return 'Object(' + JSON.stringify(val) + ')';
        } catch (_) {
            return 'Object';
        }
    }
    // errors
    if (val instanceof Error) {
        return `${val.name}: ${val.message}\n${val.stack}`;
    }
    // TODO we could test for more things here, like `Set`s and `Map`s.
    return className;
}

function getArrayJsValueFromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    const mem = getDataViewMemory0();
    const result = [];
    for (let i = ptr; i < ptr + 4 * len; i += 4) {
        result.push(wasm.__wbindgen_externrefs.get(mem.getUint32(i, true)));
    }
    wasm.__externref_drop_slice(ptr, len);
    return result;
}

function getArrayU8FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return getUint8ArrayMemory0().subarray(ptr / 1, ptr / 1 + len);
}

let cachedDataViewMemory0 = null;
function getDataViewMemory0() {
    if (cachedDataViewMemory0 === null || cachedDataViewMemory0.buffer.detached === true || (cachedDataViewMemory0.buffer.detached === undefined && cachedDataViewMemory0.buffer !== wasm.memory.buffer)) {
        cachedDataViewMemory0 = new DataView(wasm.memory.buffer);
    }
    return cachedDataViewMemory0;
}

function getStringFromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return decodeText(ptr, len);
}

let cachedUint16ArrayMemory0 = null;
function getUint16ArrayMemory0() {
    if (cachedUint16ArrayMemory0 === null || cachedUint16ArrayMemory0.byteLength === 0) {
        cachedUint16ArrayMemory0 = new Uint16Array(wasm.memory.buffer);
    }
    return cachedUint16ArrayMemory0;
}

let cachedUint8ArrayMemory0 = null;
function getUint8ArrayMemory0() {
    if (cachedUint8ArrayMemory0 === null || cachedUint8ArrayMemory0.byteLength === 0) {
        cachedUint8ArrayMemory0 = new Uint8Array(wasm.memory.buffer);
    }
    return cachedUint8ArrayMemory0;
}

function handleError(f, args) {
    try {
        return f.apply(this, args);
    } catch (e) {
        const idx = addToExternrefTable0(e);
        wasm.__wbindgen_exn_store(idx);
    }
}

function isLikeNone(x) {
    return x === undefined || x === null;
}

function passArray16ToWasm0(arg, malloc) {
    const ptr = malloc(arg.length * 2, 2) >>> 0;
    getUint16ArrayMemory0().set(arg, ptr / 2);
    WASM_VECTOR_LEN = arg.length;
    return ptr;
}

function passArrayJsValueToWasm0(array, malloc) {
    const ptr = malloc(array.length * 4, 4) >>> 0;
    for (let i = 0; i < array.length; i++) {
        const add = addToExternrefTable0(array[i]);
        getDataViewMemory0().setUint32(ptr + 4 * i, add, true);
    }
    WASM_VECTOR_LEN = array.length;
    return ptr;
}

function passStringToWasm0(arg, malloc, realloc) {
    if (realloc === undefined) {
        const buf = cachedTextEncoder.encode(arg);
        const ptr = malloc(buf.length, 1) >>> 0;
        getUint8ArrayMemory0().subarray(ptr, ptr + buf.length).set(buf);
        WASM_VECTOR_LEN = buf.length;
        return ptr;
    }

    let len = arg.length;
    let ptr = malloc(len, 1) >>> 0;

    const mem = getUint8ArrayMemory0();

    let offset = 0;

    for (; offset < len; offset++) {
        const code = arg.charCodeAt(offset);
        if (code > 0x7F) break;
        mem[ptr + offset] = code;
    }
    if (offset !== len) {
        if (offset !== 0) {
            arg = arg.slice(offset);
        }
        ptr = realloc(ptr, len, len = offset + arg.length * 3, 1) >>> 0;
        const view = getUint8ArrayMemory0().subarray(ptr + offset, ptr + len);
        const ret = cachedTextEncoder.encodeInto(arg, view);

        offset += ret.written;
        ptr = realloc(ptr, len, offset, 1) >>> 0;
    }

    WASM_VECTOR_LEN = offset;
    return ptr;
}

function takeFromExternrefTable0(idx) {
    const value = wasm.__wbindgen_externrefs.get(idx);
    wasm.__externref_table_dealloc(idx);
    return value;
}

let cachedTextDecoder = new TextDecoder('utf-8', { ignoreBOM: true, fatal: true });
cachedTextDecoder.decode();
const MAX_SAFARI_DECODE_BYTES = 2146435072;
let numBytesDecoded = 0;
function decodeText(ptr, len) {
    numBytesDecoded += len;
    if (numBytesDecoded >= MAX_SAFARI_DECODE_BYTES) {
        cachedTextDecoder = new TextDecoder('utf-8', { ignoreBOM: true, fatal: true });
        cachedTextDecoder.decode();
        numBytesDecoded = len;
    }
    return cachedTextDecoder.decode(getUint8ArrayMemory0().subarray(ptr, ptr + len));
}

const cachedTextEncoder = new TextEncoder();

if (!('encodeInto' in cachedTextEncoder)) {
    cachedTextEncoder.encodeInto = function (arg, view) {
        const buf = cachedTextEncoder.encode(arg);
        view.set(buf);
        return {
            read: arg.length,
            written: buf.length
        };
    };
}

let WASM_VECTOR_LEN = 0;


let wasm;
export function __wbg_set_wasm(val) {
    wasm = val;
}
